import React from 'react'
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import LandingPage from './routes/LandingPage'
import HomePage from './routes/HomePage'
import GamePage from './routes/GamePage'
import LoginPage from './routes/LoginPage'
import LeaderboardPage from './routes/LeaderboardPage'
import ProfilePage from './routes/ProfilePage'
import WinnersPage from './routes/WinnersPage'
import CategoryPage from './routes/CategoryPage'
import SubscriptionPage from './routes/SubscriptionPage'
import OtpPage from './routes/OtpPage'
import LanguageSelector from './component/LanguageSelector'
import Auth from './Auth/Auth'
import ConfirmationPage from './routes/ConfirmationPage'
import LowBalancePage from './routes/LowBalancePage'

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <>
          <LandingPage />
          <LanguageSelector />
        </>
      )
    },
    // Operator subscription and OTP flows removed: direct redirect to login
    // {
    //   path: "/subscribe",
    //   element: <Navigate to="/login" replace />
    // },
    // {
    //   path: "/otp",
    //   element: <Navigate to="/login" replace />
    // },
        {
      path: "/subscribe",
      element: (
        <>
          <SubscriptionPage />
          <LanguageSelector />
        </>
      )
    },
         {
      path: "/low-balance",
      element: (
        <>
          <LowBalancePage />
          <LanguageSelector />
        </>
      )
    },
    {
      path: "/otp",
      element: (
        <>
          <OtpPage />
          <LanguageSelector />
        </>
      )
    },
    {
      path: "/login",
      element: (
        <>
          <LoginPage />
          <LanguageSelector />
        </>
      )
    },
        {
      path: "/confirm",
      element: (
        <>
          <ConfirmationPage />
          <LanguageSelector />
        </>
      )
    },
    // Protected content pages (Direct access upon registered mobile login)
    {
      path: "/home",
      element: (
        <Auth>
          <HomePage />
          <LanguageSelector />
        </Auth>
      )
    },
    {
      path: "/category",
      element: (
        <Auth>
          <CategoryPage />
          <LanguageSelector />
        </Auth>
      )
    },
    {
      path: "/game",
      element: (
        <Auth>
          <GamePage />
        </Auth>
      )
    },
    {
      path: "/winners",
      element: (
        <Auth>
          <WinnersPage />
          <LanguageSelector />
        </Auth>
      )
    },
    {
      path: "/leaderboard",
      element: (
        <Auth>
          <LeaderboardPage />
          <LanguageSelector />
        </Auth>
      )
    },
    {
      path: "/profile",
      element: (
        <Auth>
          <ProfilePage />
          <LanguageSelector />
        </Auth>
      )
    },
    // Fallback for any unknown route
    {
      path: "*",
      element: <Navigate to="/" replace />
    }
  ])

  return (
    <RouterProvider router={router} />
  )
}

export default App